import { createEnv, envBoolean, envString, z } from '@percent/utility'

export const env = createEnv({
  schema: {
    NODE_ENV: z.string().optional(),
    NX_PUBLIC_REACT_APP_ENV: envString(),
    NX_PUBLIC_REACT_APP_ENV_DISPLAY_NAME: z.string().optional(),
    NX_PUBLIC_REACT_APP_ENV_PREFIX: z.string().optional(),
    NX_PUBLIC_URL: z.string().optional(),
    NX_PUBLIC_TEST_MODE: envBoolean().optional(),
    NX_PUBLIC_API_URL: envString(),
    NX_PUBLIC_APP_URL: envString(),
    NX_PUBLIC_APP_TERMS_URL: envString(),
    NX_PUBLIC_APP_PRIVACY_AND_POLICY_URL: envString(),
    NX_PUBLIC_DONATION_WIDGET_URL: envString(),
    NX_PUBLIC_DONATION_LINK: envString(),
    NX_PUBLIC_PK_KEY: envString(),
    NX_PUBLIC_ORG_SEARCH_PK_KEY: envString(),
    NX_PUBLIC_USE_SENTRY_LOGGER: envBoolean().optional(),
    NX_PUBLIC_SENTRY_DSN: z.string().optional(),
    NX_PUBLIC_HDGW_URL: envString(),
    NX_PUBLIC_ZENDESK_CHAT_KEY: z.string().optional(),
    NX_PUBLIC_CAUSE_PORTAL_GOOGLE_MAPS_API_KEY: z.string().optional(),
    NX_PUBLIC_CAUSE_PORTAL_GOOGLE_RECAPTCHA_ENTERPRISE_KEY: z.string().optional(),
    NX_PUBLIC_CAUSE_PORTAL_ZENDESK_CHAT_KEY: z.string().optional(),
    NX_PUBLIC_CAUSE_PORTAL_POPUP_SHORT_BREAK_TIME: z.string().optional(),
    NX_PUBLIC_CAUSE_PORTAL_POPUP_LONG_BREAK_TIME: z.string().optional(),
    NX_PUBLIC_CAUSE_PORTAL_NOTIFICATION_BANNER_TEXT_KEY: z.string().optional(),
    NX_PUBLIC_CAUSE_PORTAL_NOTIFICATION_BANNER_BUTTON_KEY: z.string().optional(),
    NX_CAUSE_PORTAL_NOTIFICATION_BANNER_URL: z.string().optional(),
    NX_PUBLIC_HUBSPOT_PORTAL_ID: z.string().optional(),
    NX_PUBLIC_HUBSPOT_FORM_ID: z.string().optional(),
    NX_PUBLIC_REACT_APP_HUBSPOT_WIDGET_KEY: z.string().optional(),
    NX_PUBLIC_REACT_APP_SEGMENT_WRITE_KEY: z.string().optional(),
    NX_PUBLIC_USE_SEGMENT_PROXY: envBoolean().optional(),
    NX_PUBLIC_USE_APP_CUES: envBoolean().optional(),
    NX_PUBLIC_USE_PLAUSIBLE: envBoolean().optional(),
    NX_PUBLIC_POSTHOG_API_KEY: z.string().optional(),
    NX_PUBLIC_RECAPTCHA_SITE_KEY: z.string().optional(),
    NX_PUBLIC_POSTHOG_BACKEND_PROJECT_KEY: z.string().optional(),
    REACT_APP_VERCEL_GIT_COMMIT_SHA: z.string().optional(),
    NX_PUBLIC_STORYBLOK_PUBLIC_ACCESS_TOKEN: z.string().optional(),
    NX_PUBLIC_STORYBLOK_PREVIEW_ACCESS_TOKEN: z.string().optional(),
    NX_PUBLIC_REACT_APP_GEOLOCATION_API_KEY: z.string().optional()
  }
})
